const {
  ACCESSORY_IMAGES,
  ACCESSORY_DEFAULT_IMAGE,
} = require("../../constants");

const getAccessoryImagePath = accessoryId => {
  const accessoryImage =
    Object.values(ACCESSORY_IMAGES).find(value =>
      value.includes(accessoryId)
    ) ?? ACCESSORY_DEFAULT_IMAGE;

  return `/images/gallery/accessory/${accessoryImage}.jpg`;
};

module.exports = { getAccessoryImagePath };
